import React, {Component,PropTypes}  from 'react';
import {toJS,reaction} from 'mobx';
import {PullRefresh,ProgressState} from '../../../../index';
import RefList from '../component/RefList';
import './RefPage.less';
import tools from '../../../../utils/tools';
import {TopNavPage} from 'mutants-mobile-navigator';
import stores from '../../../stores';
import RefPageView from '../view/RefPageView';
const {queryStore} = stores;


@TopNavPage
class RefPage extends Component {

  constructor(props) {
    super(props);
    console.log('props=======',props.location.state);
  }

  navTitle(){
    let title = this.props.location.state.name || (this.props.location.state.chose && this.props.location.state.chose.title);
    return title;
  }


  navBack(){
    return true;
  }


  navRightContent(){
    if (!queryStore.refModel.multiSelect){
      return <span onClick = {this.clearSelecteds} >清除</span>;
    }
  }

  clearSelecteds = ()=>{
    this.refs.refPageView.clear();
    this.refs.refPageView.ok();
  }

  render() {
    return (<RefPageView ref='refPageView' {...this.props}/>)
  }
}

export default RefPage;
